module.exports = __webpack_public_path__ + "media/images/ubs-4e5fd60c9d1d450e20a4b7f65c1c0999.png";